const state = {
    sm_partners: [],
    sm_partner: {},
    sm_partner_types: [],
    sm_partner_legal_forms: []
}

export default state;
